import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { LibSharedComponentModule } from '../../lib-shared-component.module';
import { SvcValidationMessageModule } from '../../svc-validation-message/svc-validation-message.module';

import { SvcTextAreaComponent } from './svc-text-area.component';
import { TranslocoModule } from '@ngneat/transloco';


@NgModule({
  declarations: [
    SvcTextAreaComponent
  ],
  exports: [
    SvcTextAreaComponent
  ],
  imports: [
    LibSharedCommonModule, 
    LibSharedComponentModule,
    SvcValidationMessageModule,
    TranslocoModule
  ]
})
export class SvcTextAreaModule { }
